import useAsyncData from "../../../hooks/use-async-data";
import TaxiOfficerDetails from "./taxi-officer-details";
import TaxiOfficerDetailsParams from "./taxi-officer-details-params";
import taxiOfficerService from "../taxi-officer.service";

const useTaxiOfficerDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<TaxiOfficerDetails | null>(null);

  const load = async (
    params: TaxiOfficerDetailsParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiOfficerDetails = await taxiOfficerService.getDetails(
        params,
        signal,
      );

      setData(taxiOfficerDetails);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useTaxiOfficerDetails;
